import styled from 'styled-components';
import { SYS_BORDER_RADIUS_MD } from '@oneaudi/unified-web-common';
import { DISPLAY_SIZE } from './global.style.constants';
const deviceMediaProperties = {
    desktop: `(min-width:${DISPLAY_SIZE.DESKTOP})`,
    largeDesktop: `(min-width:${DISPLAY_SIZE.LARGE_DESKTOP})`,
    smallDesktop: `(min-width:${DISPLAY_SIZE.SMALL_DESKTOP})`,
    mobile: `(max-width:${DISPLAY_SIZE.MOBILE})`,
    tablet: `(min-width: ${DISPLAY_SIZE.TABLET})`,
    smallTablet: `(max-width: ${DISPLAY_SIZE.TABLET})`,
};
export const Container = styled.dialog `
  border: none;
  ${process.env.IS_LEGACY
    ?
        (props) => `background-color: ${props.theme.sys.color.canvas.default}`
    : ''};
  height: auto;
  left: 50%;
  max-height: 65vh;
  overflow-y: auto;
  padding: 48px 60px 60px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 649px;
  z-index: auto;

  &.two-click-alpha {
    background: linear-gradient(134deg, hsla(216, 18%, 21%, 1) 0%, hsla(216, 20%, 17%, 1) 100%);
    border-radius: ${SYS_BORDER_RADIUS_MD};
    /* TODO - rever this when tested on DS */
    /* box-shadow: inset 0px 0px 0px 1px hsla(216, 17%, 26%, 1); */
  }
  .confirm-button {
    @media ${deviceMediaProperties.smallTablet} {
      width: 100%;
    }

    @media ${deviceMediaProperties.tablet} {
      margin-right: 16px;

      width: ${(props) => props.longestButtonId === 'redirect-button'
    ? `${props.longestButtonWidth}px` || 'auto'
    : 'auto'};
    }

    ${!process.env.IS_LEGACY
    ? `
      &:disabled {
        color: rgba(255, 255, 255, 0.6) !important;
      }
    `
    : ''}
  }

  .redirect-button {
    @media ${deviceMediaProperties.smallTablet} {
      width: 100%;
    }

    @media ${deviceMediaProperties.tablet} {
      width: auto;
    }
  }

  @media ${deviceMediaProperties.smallDesktop} {
    bottom: unset;
  }

  @media ${deviceMediaProperties.smallTablet} {
    bottom: 0;
    padding: 48px 30px 60px;
    top: 158px;
    transform: translate(-50%, 0);
    max-height: 70vh;
    width: calc(100% - 56px);
  }

  @media ${deviceMediaProperties.mobile} {
    max-height: 50vh;
    overflow: auto;
    top: 158px;
    transform: translate(-50%, 0);
  }
`;
export const CloseButton = styled.button `
  background-color: transparent;
  border: 0;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 20px;
`;
export const Heading = styled.div `
  h2 {
    /* ${process.env.IS_LEGACY
    ? `
        
        font-size: 32px;
        font-style: normal;
        font-weight: 400;
        letter-spacing: 0.0001em;
        line-height: 40px;
      `
    : ''} */
    margin: 0 0 24px;
  }
`;
export const BodyText = styled.div `
  p,
  span {
    /* ${process.env.IS_LEGACY
    ? `
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        letter-spacing: 0.0002em;
        line-height: 20px;
      `
    : ''} */
    margin: 0 0 24px;
  }
  margin-bottom: 36px;
  a {
    svg {
      display: none;
    }
  }
`;
export const ToggleContainer = styled.div `
  margin: 0 0 36px;
`;
